import type { SVGProps } from "react";

const SvgMonetaLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 46.08 46.08"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <clipPath id="monsvga">
      <path d="M0 0h46.08v46.08H0z" />
    </clipPath>
    <g clipPath="url(#monsvga)">
      <path
        style={{
          fill: "url(#mongsvgb)",
        }}
        transform="translate(0 -1.535)scale(.13984)"
        d="M0 0h329.52v351.47H0z"
      />
      <path
        d="M164.86 162.06 88.06 87.8v175.81l76.44-73.92 14.48-13.97h-.02l43.09-41.68v83.35l-28.97-28.03-14.13 13.62 62.71 60.63V87.8l-76.79 74.26zm-57.2 55.32v-83.35l43.09 41.67z"
        style={{
          fill: "#fff",
          fillRule: "nonzero",
        }}
        transform="translate(-.014 -1.53)scale(.13984)"
      />
    </g>
    <defs>
      <linearGradient
        id="mongsvgb"
        x1={0}
        y1={0}
        x2={1}
        y2={0}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-44.999 415.079 179.61)scale(481.53)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#140757",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.25}
          style={{
            stopColor: "#140757",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.29}
          style={{
            stopColor: "#270852",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.43}
          style={{
            stopColor: "#6c0f42",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.55}
          style={{
            stopColor: "#a31435",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.66}
          style={{
            stopColor: "#cb182b",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.75}
          style={{
            stopColor: "#e41b26",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.8}
          style={{
            stopColor: "#ed1c24",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#ed1c24",
            stopOpacity: 1,
          }}
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgMonetaLogo;
